import { Component, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { BusinessService } from '../_service/business.service';
import { TimeZoneCode } from '../models/time-objects.model';
import { Country } from '../models/country.model';
import { Currency } from '../models/currency.model';
import { Locale } from '../models/locale.model';
import { HibernateData } from '../models/hibernate-data.model';
import { FormControl } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-account-management',
  standalone: false,
  providers: [provideNativeDateAdapter()],
  templateUrl: './account-management.component.html',
  styleUrl: './account-management.component.css',
})
export class AccountManagementComponent implements OnInit {
  configList: any;
  staffName: string;
  business: Business;
  accessibleMode: boolean = false;



  constructor(private businessService: BusinessService) {
    this.business = businessService.getBusiness();
    this.staffName = businessService.getLoginResponse().staffName;
    this.configList = this.businessService.getConfigList();
  }

 ngOnInit() {
  }
}
